import { EquipmentTypeData } from '@models/interfaces';

export const equipmentTypeDefaultValue: EquipmentTypeData = {
  id: '',
  name: '',
  manufacturers: [],
};
